module.exports = __webpack_public_path__ + "static/qr_JinChang.6b6168fe.png";